import { Card, TribeId } from './data/cards/types';
import { countTribesOnBoard, tribeWeight } from './tribeSystem';

/**
 * Helper functions for calculating tribe/faction synergies.
 * Updated for 6 sub-tribe system.
 */

export interface CardInstance extends Card {
  instanceId: string;
}

/**
 * Counts the number of units with a specific faction on the board
 */
export function countFaction(board: CardInstance[], faction: 'emo' | 'cholo'): number {
  return board.filter(card => card.faction === faction).length;
}

/**
 * Counts a board's contribution to a tribe's breakpoints. Weighted, so a
 * Teniente Joven counts double (see `tribeWeight`).
 */
export function countTribe(board: CardInstance[], tribe: TribeId): number {
  return board
    .filter(card => card.tribe === tribe)
    .reduce((sum, card) => sum + tribeWeight(card), 0);
}

/**
 * Counts the number of units with a specific tag on the board
 */
export function countTag(board: CardInstance[], tag: string): number {
  return board.filter(card => card.tags.includes(tag)).length;
}

export interface BoardStatsSummary {
  emoCount: number;
  choloCount: number;
  tribeCounts: Partial<Record<TribeId, number>>;
  tokens: number;
  scalingPieces: number;
}

/**
 * Returns a summary of board statistics useful for AI and synergy calculations
 */
export function getBoardStatsSummary(board: CardInstance[]): BoardStatsSummary {
  const tribeCounts: Partial<Record<TribeId, number>> = {};
  const tribeMap = countTribesOnBoard(board);
  tribeMap.forEach((count, tribe) => {
    tribeCounts[tribe] = count;
  });

  return {
    emoCount: countFaction(board, 'emo'),
    choloCount: countFaction(board, 'cholo'),
    tribeCounts,
    tokens: countTag(board, 'token'),
    scalingPieces: countTag(board, 'scaling')
  };
}
